import { useLocation } from "wouter";
import { Card } from "@/components/ui/card";
import { ChevronLeft, Ban } from "lucide-react";

export default function BuyTokensPage() {
  const [, navigate] = useLocation();

  return (
    <div className="min-h-auto bg-[#18181B] flex flex-col h-full">
      <div className="max-w-5xl mx-auto px-5 pb-8 h-[100%] flex flex-col">
        {/* Header with back button */}

        <div
          role="banner"
          className="
            sticky
            top-0
            left-[20px]
            z-10
            bg-[#181b1b]
            pb-[12px]
            backdrop-blur-[8px]
            mb-[12px]
            h-auto
            flex
            items-center
            justify-start
            gap-2
            text-white
            py-3
          "
          >
					<button
						type="button"
						aria-label="Go back"
						onClick={() => navigate('/')}
						className="h-8 w-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
					>
						<ChevronLeft className='h-[22px] w-[22px] text-[#ffffff]'/>
					</button>

					<h1 className="text-[20px] leading-[18px] font-bold font-montserrat tracking-wide">
            Buy Tokens
					</h1>
				</div>

        {/* Suspended Notice */}
        <div className="flex-1 flex items-center justify-center">
          <Card className="py-8 px-6 rounded-[12px] text-center flex flex-col items-center gap-5 bg-[#2F2F32] border-0 opacity-60 max-w-md">
            <div className="h-16 w-16 rounded-full bg-white/5 flex items-center justify-center">
              <Ban className="h-8 w-8 text-[#BABABB]" />
            </div>

            <div className="flex flex-col gap-2">
              <h2 className="text-lg font-semibold font-figtree text-[#ffffff]">
                Token Purchases Temporarily Suspended
              </h2>
              <p className="text-[13px] leading-[18px] text-[#BABABB] font-figtree">
                We're currently unable to process token purchases. We apologize
                for the inconvenience and are working to restore this service as
                soon as possible.
              </p>
            </div>

            <p className="text-xs text-[#BABABB]/70 font-figtree">
              Please check back later. Thank you for your patience.
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}
